
import { Options, Vue } from "vue-class-component";
import SideMenu from "@/components/WorkBench/SideMenu.vue";
import * as echarts from "echarts";
import {
  dispatchAovPerformanceCopy,
  dispatchGetAovPerformances,
  dispatchGetPerformanceAovTrend,
  dispatchPerformanceAovEmail,
  dispatchRecentTaskrecord,
  dispatchtaskRecordDevices,
  dispatchtaskRecordQuery,
} from "@/store/performance/actions";
import { getLocalProject } from "@/utils";
import {
  readAovPerformances,
  readPerformanceAovTrend,
  readPerformanceSelectOptions,
  readRecentTaskrecord,
  readTaskRecordDevices,
  readTaskRecordQuery,
} from "@/store/performance/getters";
import { readMyProjects } from "@/store/project/getters";
import { readDeviceSpecs } from "@/store/device/getters";
import { store } from "@/store";
import { dispatchGetPerformanceSelectOptions } from "@/store/performance/actions";
import {} from "@/store/performance/getters";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import { readUserProfile } from "@/store/main/getters";
import { ElMessage } from "element-plus";

// 任务执行详情页面
@Options({
  components: {
    SideMenu,
  },
})
export default class CustomReport extends Vue {
  public loading = false;
  public mustVal = {
    taskRecordId: "", //任务记录id
    Interval: 2, //间隔标红
  };
  public copyVal = {
    taskRecordId: "", //任务记录id
    deviceVal: "", //任务记录设备
  };
  public Level: any[] = [
    { label: "超高端机型", value: 0 },
    { label: "高端机型", value: 1 },
    { label: "中端机型", value: 2 },
    { label: "低端机型", value: 3 },
    { label: "超低端机型", value: 4 },
  ];
  public localProject = Number(getLocalProject());
  public PerfFields = [
    { label: "版本", prop: "game_version", width: "120", fixed: true },
    { label: "机型", prop: "device_id", width: "100", fixed: true },
    { label: "日期", prop: "timestamp", width: "150", fixed: true },
    { label: "平均帧率", prop: "avg_fps" },
    { label: "loading时间均值", prop: "loadingtime" },
    { label: "帧率>18比例(%)", prop: "fps_lt_18_pcnt" },
    { label: "帧率>25比例(%)", prop: "fps_lt_25_pcnt" },
    { label: "帧率方差", prop: "zlfc" },
    { label: "单帧>100ms比例(%)", prop: "lag_cnt" },
    { label: "卡顿次数(10m)", prop: "yzkd" },
    { label: "严重卡顿次数(10m)", prop: "yzkd" },
    { label: "PSS内存均值(MB)", prop: "pss" },
    { label: "PSS内存峰值(MB)", prop: "max_pss" },
    { label: "Mono已用内存峰值(MB)", prop: "max_mono_used" },
    { label: "Mono堆内存峰值(MB)", prop: "monomem" },
    { label: "GC次数", prop: "gc" },
    { label: "DrawCall均值", prop: "dc" },
    { label: "三角形数均值", prop: "Tris" },
    { label: "顶点数均值", prop: "Verts" },
    { label: "UI_dc", prop: "UI_dc" },
    { label: "Scene_dc", prop: "Scene_dc" },
    { label: "Particle_dc", prop: "Particle_dc", width: "120" },
    { label: "FrameSync", prop: "FrameSync", width: "120" },
    { label: "LogicThr", prop: "LogicThr" },
    { label: "SleepTime", prop: "SleepTime", width: "120" },
    { label: "PostTime", prop: "PostTime" },
    { label: "平均CPU", prop: "avg_cpu" },
    { label: "最高温度", prop: "zgwd" },
  ];

  public get screenshot() {
    if ("screenshot" in this.$route.query) {
      return false;
    } else {
      return true;
    }
  }

  public async mounted() {
    this.loading = true;
    // console.log(this.$route.query.task_record_id, this.$route.query.project)
    if (this.$route.query.task_record_id && this.$route.query.project) {
      this.localProject = Number(this.$route.query.project);
    }
    await dispatchGetDeviceSpecs(store, { project: this.localProject }); //获取所有设备详情列表
    await dispatchRecentTaskrecord(store, { project: this.localProject }); //表格对应label
    // 下拉框
    await dispatchGetPerformanceSelectOptions(store, {
      project: this.localProject,
    });
    this.mustVal.taskRecordId =
      this.RecentTaskrecord.length > 0 ? this.RecentTaskrecord[0]?.value : "";
    if (this.$route.query.task_record_id && this.$route.query.project) {
      this.mustVal.taskRecordId = this.$route.query.task_record_id.toString();
    }
    await dispatchGetAovPerformances(store, {
      project: this.localProject,
      task_record_id: this.mustVal.taskRecordId,
      interval: 2,
    });
    await dispatchtaskRecordQuery(store, {
      project: this.localProject,
      task_record_id: Number(this.mustVal.taskRecordId),
    }); //aov复制数据需要的任务记录列表接口
    this.copyVal.taskRecordId =
      this.TaskRecordQuery.length > 0
        ? this.TaskRecordQuery[0]?.id.toString()
        : "";
    await dispatchtaskRecordDevices(store, {
      project: this.localProject,
      task_record_id: Number(this.copyVal.taskRecordId),
    }); //获取任务记录的设备
    this.copyVal.deviceVal =
      this.TaskRecordDevices.length > 0
        ? this.TaskRecordDevices[0]?.id.toString()
        : "";
    await this.get_is_super; //是否是管理员
    await dispatchGetPerformanceAovTrend(store, {
      project: this.localProject,
      task_record_id: Number(this.mustVal.taskRecordId),
    });
    await this.PerformanceAovTrend.map((item, index) => {
      this.performanceTrends_echarts(
        index,
        this.all_device_options[index].label
      ); //图表
    });
    this.loading = false;
    // 从浏览器触发发送报告
    if ("screenshot" in this.$route.query) {
      this.Sendout();
    }
  }
  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }

  //记录id下拉框
  public get RecentTaskrecord() {
    return readRecentTaskrecord(store);
  }

  // 获取下拉选择框
  public get performace_select_options() {
    const options = readPerformanceSelectOptions(store);
    return options;
  }

  // 获取复制需要的任务id下拉框
  public get TaskRecordQuery() {
    return readTaskRecordQuery(store);
  }

  // 获取复制需要的设备数据下拉框
  public get TaskRecordDevices() {
    return readTaskRecordDevices(store);
  }
  //复制的接口
  public async CopyBtn() {
    this.loading = true;
    await dispatchAovPerformanceCopy(store, {
      project: this.localProject,
      from: Number(this.copyVal.taskRecordId),
      to: Number(this.mustVal.taskRecordId),
      device: this.copyVal.deviceVal,
    });
    await dispatchGetAovPerformances(store, {
      project: this.localProject,
      task_record_id: Number(this.mustVal.taskRecordId),
      interval: Number(this.mustVal.Interval),
    });
    await dispatchGetPerformanceAovTrend(store, {
      project: this.localProject,
      task_record_id: Number(this.mustVal.taskRecordId),
    });
    this.resBase64 = [];
    this.PerformanceAovTrend.map((item, index) => {
      this.performanceTrends_echarts(
        index,
        this.all_device_options[index].label
      ); //图表
    });
    this.loading = false;
  }

  // 复制接口禁用
  public get interfaceDisabled() {
    let disabled = false;
    if (
      this.get_is_super ||
      this.copyVal.taskRecordId === "" ||
      this.copyVal.deviceVal === ""
    ) {
      disabled = true;
    }
    return disabled;
  }

  public get getDeviceSpecs() {
    return readDeviceSpecs(store);
  }

  // 切换复制的id时，更新设备数据
  public async equipmentUpdate() {
    await dispatchtaskRecordDevices(store, {
      project: this.localProject,
      task_record_id: Number(this.copyVal.taskRecordId),
    });
    this.copyVal.deviceVal = this.TaskRecordDevices[0]?.id.toString();
  }
  // 切换id时,复制的id更新
  public async RecordIdUpdate() {
    await dispatchtaskRecordQuery(store, {
      project: this.localProject,
      task_record_id: Number(this.mustVal.taskRecordId),
    }); //aov复制数据需要的任务记录列表接口
    this.copyVal.taskRecordId = this.TaskRecordQuery[0]?.id.toString();

    await dispatchtaskRecordDevices(store, {
      project: this.localProject,
      task_record_id: Number(this.copyVal.taskRecordId),
    });
    this.copyVal.deviceVal = this.TaskRecordDevices[0]?.id.toString();
  }
  // 设备
  public get all_device_options() {
    const devices = this.PerformanceAovTrend;
    const device_select: any[] = [];
    devices.forEach((item) => {
      const device = this.getDeviceSpecs.filter(
        (device) => device.id === item.performance_briefs[0]?.device_id
      )[0];
      let name =
        this.Level.filter((item3) => item3.value === device?.level)[0]?.label +
        device?.model?.name;
      device_select.push({
        label: name,
        value: item,
      });
    });
    return device_select;
  }

  public TableRowStyle(row: any, rowIndex: any) {
    if (row.row["版本"] === "性能指标基准") {
      return "color:red";
    }
  }
  // 获取表格数据
  public get get_all_performance() {
    let res: any[] = readAovPerformances(store);
    return res;
  }

  // 获取图表数据
  public get PerformanceAovTrend() {
    return readPerformanceAovTrend(store);
  }
  // 图表
  public performanceTrends_echarts(index: any, titleVal: any) {
    let legendVal: any[] = [
      "avg_fps",
      "max_pss",
      "Jank(/10min)",
      "loadingtime",
      "monomem",
      "avg_dc",
      "FrameSync",
    ];
    let legendVal2: any[] = [
      "平均帧率",
      "内存峰值",
      "卡顿次数(10m)",
      "loading时间均值",
      "Mono堆内存峰值",
      "Drawcall均值",
      "FrameSync",
    ];
    let seriesData: any[] = [];
    let newArr: any[] = [];
    // 数据处理
    this.PerformanceAovTrend[index]?.performance_briefs.forEach((item: any) => {
      if (item.custom_data !== undefined) {
        newArr.push({ ...item, ...JSON.parse(item.custom_data) });
        newArr.map((item: any) => {
          if (
            item.avg_dc === "" ||
            item.avg_dc === null ||
            item.avg_dc === undefined
          ) {
            item.avg_dc = item.dc;
          }
        });
      }
    });

    legendVal.forEach((item: any, index) => {
      seriesData.push({
        name: legendVal2[index],
        type: "line",
        data: getAttrs(newArr, item),
        yAxisIndex:
          ["平均帧率", "FrameSync", "loading时间均值"].indexOf(
            legendVal2[index]
          ) !== -1
            ? 0
            : 1,
        itemStyle: { normal: { label: { show: true } } },
      });
    });

    function getAttrs(array: any, attr: any) {
      var arr = array.map((item: any) => {
        return item[attr];
      });
      arr.map((item2: any, index: any) => {
        if (
          arr[index] === undefined ||
          arr[index] === null ||
          arr[index] === ""
        ) {
          arr[index] = "--";
        }
      });
      return arr;
    }
    let performanceTrends: any = document.getElementById(
      "Performance_trends" + index
    );
    echarts.dispose(performanceTrends);
    let PerformanceLineChart = echarts.init(performanceTrends);
    let option;
    option = {
      title: {
        text: titleVal,
        x: "center",
        textStyle: {
          fontWeight: "normal",
          fontSize: 15,
        },
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        x: "center",
        y: "bottom",
        data: legendVal2,
      },
      grid: {
        left: "2%",
        right: "2%",
        bottom: "10%",
        top: "15%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {},
          magicType: { show: true, type: ["line", "bar"] },
        },
      },
      xAxis: {
        type: "category",
        // boundaryGap: false,
        data: this.PerformanceAovTrend[index]?.date_list,
        offset: 10,
      },
      yAxis: [
        {
          // offset: 10,
          name: "",
          type: "value",
          min: 0,
          max: 200,
          position: "left",
          axisLabel: {
            formatter: function (v: any) {
              return parseInt(v); //表示整数。其他数值类型以此类推
            },
          },
        },
        {
          // offset: 10,
          name: "",
          type: "value",
          min: 0,
          position: "right",
          axisLabel: {
            formatter: function (v: any) {
              return parseInt(v); //表示整数。其他数值类型以此类推
            },
          },
        },
      ],
      series: seriesData,
      animation: false,
    };
    PerformanceLineChart.setOption(option);
    var res_base64 = PerformanceLineChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "custom_aov" + index + ".png";
    this.resBase64.push(res);
    return PerformanceLineChart;
  }

  // 发送邮件
  public async Sendout() {
    await dispatchPerformanceAovEmail(store, {
      project: this.localProject,
      task_record_id: Number(this.mustVal.taskRecordId),
      interval: Number(this.mustVal.Interval),
      file_list: this.resBase64,
    });
    ElMessage({
      message: "报告发送中...",
      showClose: true,
    });
  }

  public resBase64: any[] = [];

  // 查询报告
  public async onSubmit() {
    this.loading = true;
    await dispatchGetAovPerformances(store, {
      project: this.localProject,
      task_record_id: Number(this.mustVal.taskRecordId),
      interval: Number(this.mustVal.Interval),
    });
    await dispatchGetPerformanceAovTrend(store, {
      project: this.localProject,
      task_record_id: Number(this.mustVal.taskRecordId),
    });
    this.resBase64 = [];
    this.PerformanceAovTrend.map((item, index) => {
      this.performanceTrends_echarts(
        index,
        this.all_device_options[index].label
      ); //图表
    });
    this.loading = false;
  }
  public Tips = "";
  public handleMouseEnter(row: any) {
    this.Tips = row.task_record_id;
  }
}
